import React from 'react'
import './footer.css'

function index() {
  return (
    <footer>© 2022 COPANGA Co, Inc. Todos os direitos reservados.</footer>
  )
}

export default index